export default {
  date: '',
  operations: [],
  blocksByDate: [],
  playgrounds: [],
  activities: ['all'],
}
